import type { ReactNode } from "react";
import {
	DatePicker,
	DatePickerDefaultFooter,
	type DateRange,
} from "@/v2/components/date-picker/DatePicker";
import { isCompleteDateRange } from "@/v2/lib/dates";

export type { DateRange };

interface DateBarProps {
	date: Date;
	dateRange: Partial<DateRange>;
	onDateChange: (date: Date) => void;
	onDateRangeChange: (range: DateRange) => void;
	leftSlot?: ReactNode;
	rightSlot?: ReactNode;
}

export function DateBar({
	date,
	dateRange,
	onDateChange,
	onDateRangeChange,
	leftSlot,
	rightSlot,
}: DateBarProps) {
	const selectedDateRange = isCompleteDateRange(dateRange)
		? dateRange
		: { from: date, to: date };

	return (
		<div className="flex items-center justify-between px-2 py-1">
			{/* Left slot (filter) */}
			{leftSlot ?? <div className="w-10" />}

			{/* Date selector — center */}
			<DatePicker
				className="w-fit"
				dateRange={selectedDateRange}
				onDateChange={onDateChange}
				onDateRangeChange={onDateRangeChange}
				selectionMode="range"
				bottomSlot={DatePickerDefaultFooter}
			/>

			{/* Right slot (sort/options) */}
			{rightSlot ?? <div className="w-10" />}
		</div>
	);
}
